<footer [class]="layout">
  <div class="container">
    <div class="footer-widget">
      <div class="row">
        <div class="col-lg-4 col-sm-5 order-1">
          <div class="site-info-widget mb-4">
            <div class="footer-logo">
              <img [src]="logo" width="40%" alt="logo" />
            </div>
            <!-- <p>
              Power of choice is untrammelled & when nothing prevents our being
              able
            </p>
            <ul class="social-links">
              <li>
                <a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-instagram"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-behance"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-dribbble"></i></a>
              </li>
            </ul> -->
          </div>
        </div>
        <!-- <div class="col-lg-8 col-sm-7 order-2">
          <div class="widget newsletter-widget">
            <h4 class="widget-title">Subscribe Our Newsletters</h4>
            <div class="newsletter-form">
              <form>
                <input type="email" placeholder="Enter Your Email" />
                <button type="submit" class="main-btn">Subscribe Now</button>
              </form>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-lg-3 col-sm-6 order-3">
          <div class="widget nav-widget">
            <h4 class="widget-title">Quick Links</h4>
            <ul>
              <li><a href="#">Company History</a></li>
              <li><a href="#">Latest News & Blog</a></li>
              <li><a href="#">Popular Services</a></li>
              <li><a href="#">Business & Consulting</a></li>
              <li><a href="#">Financial Planning</a></li>
            </ul>
          </div>
        </div> -->
        <div class="col-lg-12 order-lg-12 order-5">
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="widget nav-widget" *transloco="let t; read: 'footer'">
                <h4 class="widget-title">
                  {{ t("title1") }}
                </h4>
                <p>
                  {{ t("text1") }}
                </p>
                <ul class="social-links mt-4">
                  <li>
                    <a
                      href="https://www.facebook.com/goodysolution"
                      class="px-2"
                      target="_blank"
                      ><i class="fab fa-facebook-f" style="font-size: 35px"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCrsPxyluUoWJLXt_woFIpXw"
                      class="px-2"
                      target="_blank"
                      ><i class="fab fa-youtube" style="font-size: 35px"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="widget contact-widget">
                <h4 class="widget-title" *transloco="let t; read: 'footer'">
                  {{ t("title2") }}
                </h4>
                <!-- <p>455/35 Param 6 Rd. Ratchathewi Bangkok Thailand</p> -->
                <ul class="contact-infos">
                  <li>
                    <a
                      href="https://goo.gl/maps/meeMeRxiZ1nacTmp8"
                      target="_blank"
                      *transloco="let t; read: 'address'"
                    >
                      <i class="far fa-map-marker-alt"></i>{{ t("text") }}
                    </a>
                  </li>
                  <li>
                    <i class="far fa-phone"></i>
                    <a href="tel:022192691">02-219-2691</a>
                  </li>
                  <li>
                    <a href="mailto:info@goodysolution.com">
                      <i class="far fa-envelope-open"></i>
                      info@goodysolution.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-sm-6 order-lg-5 order-4">
          <div class="widget insta-feed-widget">
            <h4 class="widget-title">Follow Instagram</h4>
            <div class="insta-images">
              <div
                class="insta-img"
                [style.background-image]="'url(' + item.img + ')'"
                *ngFor="let item of instagram"
              >
                <a href="#">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="footer-copyright">
      <p class="copyright-text">
        <span
          >Copy @
          <a href="https://goodysolution.com">goodysolution.com</a> 2022</span
        >
        <span>All Right Reserved Design By Goody</span>
      </p>
      <a href="javascript:void(0)" class="back-to-top" (click)="gotoTop()"
        ><i class="far fa-angle-up"></i
      ></a>
    </div>
  </div>
  <!-- Lines -->
  <!-- <img [src]="shape" alt="line-shape" [class]="shapeclass">
    <img [src]="shape2" alt="line-shape" [class]="shape2class"> -->
</footer>
